export default __webpack_public_path__ + "static/media/31.012f51fb.jpeg";